import { apiRequest } from '@scc/lib'
import type {
  AgencyOverviewRepository,
  AgencyOverviewStoreMetric,
} from '@/data/repositories/types'

interface ApiAgencyOverview {
  storeBreakdown: AgencyOverviewStoreMetric[]
}

export function createApiAgencyOverviewRepository(): AgencyOverviewRepository {
  return {
    async getMetrics(agencyId, startDate, endDate) {
      const params = new URLSearchParams({
        agencyId: String(agencyId),
        start: startDate,
        end: endDate,
      })
      const overview = await apiRequest<ApiAgencyOverview>(
        `/analytics/agency-overview?${params.toString()}`,
      )
      return overview.storeBreakdown
    },
  }
}
